import React from "react";
import { Grow, Popover, useMediaQuery, useTheme } from "@mui/material";
import styled from "@emotion/styled";

const MenuPaper = styled("div")(({ theme }) => ({
  minWidth: 300,
  maxWidth: 400,
  maxHeight: "min(72vh, 520px)",
  overflow: "visible",
  padding: "10px 10px 12px",
  borderRadius: 14,
  backgroundColor: theme.palette.mode === "dark" ? "#1E1E1E" : "#FFFFFF",
  border: `1px solid ${
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(88, 89, 91, 0.12)"
  }`,
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 18px 40px rgba(0, 0, 0, 0.55)"
      : "0 18px 40px rgba(23, 15, 74, 0.14)",
  transformOrigin: "top left",
  "@media (max-width: 600px)": {
    minWidth: "min(92vw, 400px)",
    maxWidth: "92vw",
    borderRadius: 12,
    padding: "10px 10px 12px",
  },
}));

const GrowFromChip = React.forwardRef(function GrowFromChip(props, ref) {
  return (
    <Grow
      {...props}
      ref={ref}
      timeout={{ enter: 180, exit: 120 }}
      style={{
        ...props.style,
        transformOrigin: props.style?.transformOrigin || "top left",
      }}
    />
  );
});

/**
 * Contextual menu anchored beneath an active filter chip.
 * Uses a short grow/fade so the panel feels like an extension of the chip.
 */
export default function FilterMenu({
  id,
  open,
  anchorEl,
  onClose,
  children,
  width,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: isMobile ? "center" : "left" }}
      transformOrigin={{ vertical: "top", horizontal: isMobile ? "center" : "left" }}
      marginThreshold={10}
      TransitionComponent={GrowFromChip}
      transitionDuration={{ enter: 180, exit: 120 }}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            mt: 1,
            overflow: "visible",
            background: "transparent",
            boxShadow: "none",
          },
        },
      }}
    >
      <MenuPaper
        style={
          width
            ? {
                minWidth: isMobile ? undefined : width,
                maxWidth: isMobile ? "92vw" : width,
              }
            : undefined
        }
      >
        {children}
      </MenuPaper>
    </Popover>
  );
}
